import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const RAILSTREAM_LOGO = "https://tower.railstream.net/railstream-logo-transparent.png";

// v6.04.0 Phase C.6 R-4 — operator-facing sizing suggestion, shown ONLY in
// the memory-ceiling configuration form to help operators pick a reasonable
// value. NOT used for live health coloring — the live color must reflect the
// ceiling the agent actually reports (`site.health.encoder_memory_limit_mb`).
// This suggestion never alters the configured value unless the operator
// explicitly applies it.
export const getSuggestedCeilingMb = (site) => {
  const res = site?.output?.resolution || "1080p";
  const hw = site?.encoder?.hardware || "auto";
  const codec = site?.encoder?.codec || "h264";
  const preset = site?.encoder?.preset || "medium";
  const isHw = ["nvenc", "qsv", "amf"].includes(hw);
  const resMap = { "720p": 720, "1080p": 1080, "1440p": 1440, "4k": 2160 };
  const height = res === "custom" ? (site?.output?.custom_height || 1080) : (resMap[res] || 1080);
  const presetMul = { ultrafast: 0.7, superfast: 0.8, veryfast: 1.0, faster: 1.15, fast: 1.3, medium: 1.5, slow: 2.0, slower: 2.5, veryslow: 3.0, p1: 1.0, p2: 1.0, p3: 1.0, p4: 1.0, p5: 1.0, p6: 1.0, p7: 1.0 }[preset] || 1.0;
  let base;
  if (isHw) { base = 600; }
  else {
    if (height <= 720) base = 400;
    else if (height <= 1080) base = 800;
    else if (height <= 1440) base = 1400;
    else base = 3000;
    base = Math.round(base * presetMul);
    if (codec === "h265") base = Math.round(base * 1.5);
  }
  return Math.max(512, Math.round(base * 1.4));
};

// v6.04.0 Phase C.6 R-4 — live memory color is based ONLY on the ceiling
// the agent actually reports. When the agent has not (yet) reported a
// positive ceiling, show a neutral color — do NOT silently substitute a
// default and do NOT derive a runtime threshold from resolution.
export const getMemoryColor = (memMb, site) => {
  const limit = site?.health?.encoder_memory_limit_mb;
  if (typeof limit !== "number" || limit <= 0) return "text-zinc-400";
  if (memMb > limit * 1.3) return "text-red-400";
  if (memMb > limit) return "text-amber-400";
  return "text-green-400";
};

// Status/state color helper
export const getStateColor = (state) => {
  const colors = {
    running: "text-green-400",
    transcoding: "text-green-400",
    ingest_only: "text-blue-400",
    starting: "text-amber-400",
    waiting: "text-amber-400",
    error: "text-red-400",
    idle: "text-zinc-500",
    offline: "text-zinc-500",
    online: "text-green-400",
  };
  return colors[state] || "text-zinc-500";
};
